<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.billinginvoice') }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          class="action mr-3"
          style="display: flex;align-items: center;height: 31px;"
        >
          <span
            v-for="(text, index) in textDiscounts"
            :key="index"
            class="badge badge-danger"
          >
            {{ text }}
          </span>
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BaseTable
        :pagination="pagination"
        class="custom-table"
        tableClass="table-bordered"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th>{{ $t('apps.billing.label.invoiceno') }}</th>
              <th>{{ $t('apps.billing.label.datemonth') }}</th>
              <th>{{ $t('apps.billing.label.dateperiod') }}</th>
              <th class="text-right">{{ $t('apps.billing.label.payamount') }}</th>
              <th
                style="width: 140px;"
                class="text-center">{{ $t('apps.billing.label.download') }}</th>
              <th class="text-center"/>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tr>
            <td
              v-if="empty"
              colspan="5"
              class="text-center">
              {{ $t('message.notfounddata') }}
            </td>
          </tr>
          <tbody>
            <tr
              v-for="(item, index) in mapItems"
              :key="index"
            >
              <td>
                <RouterLinkCustom
                  :status="{
                    color: item.linkIcon,
                    text: item.linkIconTooltipText,
                    type: 'icon'
                  }"
                >
                  <RouterLink
                    :to="{
                      name: 'BillingInvoiceSingle',
                      query: {
                        id: item.invId,
                        code: item.code,
                      },
                    }"
                  >
                    {{ item.code }}
                  </RouterLink>
                </RouterLinkCustom>
              </td>
              <td>
                {{ item.datePeriod }}
              </td>
              <td>
                {{ item.datePeriodTo }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(item.total, '0,0.00')) }}
              </td>
              <td class="text-center">
                <button
                  v-if="item.isPaid"
                  class="btn-link"
                  @click="onClickDownloadPdf($event, item)"
                >
                  PDF
                </button>
              </td>
              <td>
                <div
                  class="d-flex"
                  style="gap: 5px;">
                  <button
                    v-b-modal.modal-discount
                    v-if="item.isPending && isShowDiscount"
                    type="button"
                    class="btn btn-smallest btn-danger btn-pay"
                  >
                    {{ $t('message.campaign_treesoft_review_button') }}
                  </button>
                  <button
                    v-if="item.isPending"
                    type="button"
                    class="btn btn-smallest btn-info btn-pay"
                    @click="onClickPay($event, item)"
                  >
                    {{ $t('apps.billing.button.payamount', { number: getCurrencyWithNumber(numberel(item.total, '0,0.00')) }) }}
                  </button>
                </div>
                <span
                  v-if="item.isPaid"
                  class="text-success"
                >
                  {{ $t('apps.billing.status.paid') }}
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </BaseTable>

      <BaseModalGetDiscount
        @onSubmit="gotoGoogleForm()"
      />

    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'
import { BILLING_INVOICE_STATUS } from '../../../../helpers/enum'
import jwt from 'jsonwebtoken'
import BaseModalGetDiscount from '../../../base/BaseModalGetDiscount.vue'

export default {
  mixins: [tablePaginateMixin],

  components: {
    BaseModalGetDiscount,
  },

  data () {
    return {
      loading: false,
      query: {
        page: this.$route.query.page || 1,
      },
    }
  },

  computed: {
    ...mapState('billing', {
      data: 'invoiceList',
    }),
    ...mapGetters({
      getLang: 'getLang',
      getShopInfo: 'getShopInfo',
      shopInfo: 'getShopInfo',
      me: 'getMe',
      auth: 'getAuth',
      shopDiscounts: 'getShopDiscounts',
    }),
    mapItems () {
      return this.data.map((item) => {
        const isPaid = item.status === BILLING_INVOICE_STATUS.PAID
        const isPending = item.status === BILLING_INVOICE_STATUS.PENDING
        const datePeriod = this.getDateMonthYear(this.moment(item.dateEnd).subtract(1, 'month').toDate())
        const datePeriodTo = `
          ${this.getDateCustom(item.dateStart, { format: 'YYYY-MM-DD' })}
          -
          ${this.getDateCustom(item.dateEnd, { format: 'YYYY-MM-DD' })}
        `
        const linkIcon = isPaid
          ? 'success'
          : 'info'
        const linkIconTooltipText = isPaid
          ? this.$t('apps.billing.status.paid')
          : this.$t('apps.billing.status.pending')
        return {
          ...item,
          datePeriod,
          datePeriodTo,
          isPaid,
          isPending,
          linkIcon,
          linkIconTooltipText,
        }
      })
    },
    empty () {
      return !this.mapItems.length
    },
    hasInvoices() {
      return this.data.length > 0
    },
    lastInvoiceTotalInTHB() {
      let total = 0
      for (const invoice of this.data) {
        total = invoice.total
        break
      }
      return total
    },
    isShowDiscount() {
      const expiredAt = this.moment('2025-03-20')
      const daysLeft = expiredAt.diff(this.moment(), 'days', false)
      const isExpired = daysLeft <= 0
      const hasDiscount = this.shopDiscounts.some((item) => item.name === 'TreeSoft Review') === true
      const isPaidLowPrice = this.hasInvoices && this.lastInvoiceTotalInTHB < 500
      const shopRegisterAt = this.moment(this.shopInfo.created_at).unix()
      const beforeRegisterAt = this.moment('2024-11-01').unix()
      const isOldUser = shopRegisterAt < beforeRegisterAt
      return !isExpired && !hasDiscount && isPaidLowPrice && isOldUser
    },
    textDiscounts() {
      return this.shopDiscounts.map((discount) => {
        const expiredAt = this.moment(discount.expired_at)
        const monthsLeft = expiredAt.diff(this.moment(), 'months', true)
        return this.$t('message.getdiscount', {
          discount: `${discount.value_amount}${discount.value_type === 'percentage' ? '%' : ''}`,
          expire: Math.ceil(monthsLeft),
        })
      })
    },
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.billing.title'),
      current: {
        app_name: 'billing',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
      submenuAtIdx: 0,
    })
  },

  mounted () {
    this.fetchData()
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('billing', {
      getInvoiceList: 'getInvoiceList',
    }),
    ...mapActions({
      getShopDiscounts: 'getShopDiscounts',
    }),
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await Promise.all([
        this.getInvoiceList({
          page: this.query.page,
          limit: this.$store.state.app.limitRowsPerpage,
        }),
        this.getShopDiscounts(),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    onClickPay (e, item) {
      this.$router.push({ name: 'PaymentInvoice',
        query: {
          id: item.invId,
        } })
    },
    onClickDownloadPdf (e, item) {
      const data = {
        'type': 'ts_monthly_inv',
        'lang': this.getLang,
        'id': item.invId,
        'shop_id': this.getShopInfo.shop_id,
      }

      const token = jwt.sign(data, this.project.config.token.secret, { expiresIn: this.project.config.token.download_pdf_expiresin })
      const link = document.createElement('a')
      link.href = this.project.config.web.api + 'file/pdf/' + token + '/' + item.code
      link.target = '_blank'
      link.dispatchEvent(new MouseEvent('click'))
    },
    gotoGoogleForm() {
      window.open(
        `https://docs.google.com/forms/d/e/1FAIpQLSeB-YtGSN-GYPFmkUigvKtGthYQY-E2e5GIG5mMy_LQIy2GJw/viewform?usp=pp_url&entry.1015584940=${this.me.email}`,
        '_blank'
      )
    },
  },
}
</script>

<style scoped>
.btn-pay {
  position: relative;
  top: -2px;
}

.btn-link {
  border: none;
  background: none;
  text-decoration: underline;
  color: var(--link-color);
  cursor: pointer;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/billing/invoice/List.vue